var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"oct-chip",class:[{
    'oct-chip--outlined': _vm.outline,
    'oct-chip--dense': _vm.dense
  }, `oct-chip--${_vm.type}`],attrs:{"role":"row","aria-selected":_vm.selected ? 'true' : _vm.selected}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }